import { createFileRoute } from '@tanstack/react-router'
import SettingsOrganizationGeneralPage from '@/components/pages/Settings/organization/SettingsOrganizationGeneralPage/SettingsOrganizationGeneralPage'

export const Route = createFileRoute('/$workspaceName/$environment/organization-settings/general')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SettingsOrganizationGeneralPage />
}
